import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from '@datachain/ui-sdk/common';
import { map, Observable } from 'rxjs';

import { DcBaseRequester } from '../core/dc-base.requester';
import { ITracePayload, ITraceResponse } from './trace.model';

@Injectable({
	providedIn: 'root',
})
export class TraceRequester extends DcBaseRequester<ITraceResponse> {
	protected resource: string;
	protected elementsListUrl: string;
	protected singleElementUrl: string;

	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('TRACES');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public getTraces(
		offset: number,
		limit: number
	): Observable<{ list: ReadonlyArray<ITraceResponse>; total: number }> {
		const body: ITracePayload = {
			filter: [],
			sort: {},
		};
		const url = this.urlService.generateUrl(
			this.resource,
			{},
			{
				skip: offset,
				take: limit,
				project: this.projectId,
			}
		);
		return this.http
			.post<ReadonlyArray<ITraceResponse>>(url, body, {
				observe: 'response',
			})
			.pipe(
				map((response) => ({
					list: response.body ?? [],
					total: this.getTotal(response),
				}))
			);
	}

	private getTotal(
		response: HttpResponse<ReadonlyArray<ITraceResponse>>
	): number {
		return Number.parseInt(response.headers.get('x-total-count') ?? '0', 10);
	}
}
